module.exports = __webpack_public_path__ + "static/media/noImage.ef1273cf.svg";